import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted, watch, nextTick, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Select from 'primevue/select';
import { useDebounceFn } from '@vueuse/core';
import { ItemSelect } from '@/models/share.model';
import SearchPatientService from '@/services/SearchPatientService';
import { useAppUserStore } from '@/stores/appUser';


export default /*@__PURE__*/_defineComponent({
  __name: 'patientChange',
  props: {
  initialPatientSearch: {
    type: String,
    default: "",
  },
  excludePatients: {
    type: Array,
    required: false,
  }
},
  emits: ['selectedPatient'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const filteredPatients = ref<ItemSelect[]>([]);
const selectedPatient = ref(undefined);

const appUserStore = useAppUserStore();

const emits = __emit
const props = __props

const healthGroupMembershipsUuid = computed(() => {
  if (!appUserStore.currentAppUserData) {return []}
  return appUserStore.currentAppUserData.healthGroupMemberships.map((healthGroupMemberships: any) => healthGroupMemberships.instituteWithRole?.instituteWithRoleId);
});

function focus() {
  nextTick(() => {
    const inputEl = searchInputRef.value?.$el?.querySelector('input');
    inputEl?.focus();
  })
}

const searchInputRef = ref(null)

const debouncedSearchPatient = useDebounceFn((event: string) => {
  searchPatient(event);
}, 500);

const searchPatient = (event: string) => {
  setTimeout(async () => {
    if (event && typeof event === 'string') {
      SearchPatientService.searchPatient(event.toLowerCase(), healthGroupMembershipsUuid.value).then((res) => {
        let patientList = res;
          if (props.excludePatients) {
            patientList = res.filter((patient) => {
              return !props.excludePatients.includes(patient.id);
            })
          }

      filteredPatients.value = patientList})
    }
  }, 500);
};

const setSearchText = (searchText: string) => {
  nextTick(() => {
    const inputEl = searchInputRef.value?.$el?.querySelector('input');
    if (inputEl) {
      inputEl.value = searchText;
      inputEl.dispatchEvent(new Event('input', { bubbles: true }));
      inputEl.focus();
    }
  });
};

watch(
  () => selectedPatient.value,
  () => {
    if (selectedPatient.value && selectedPatient.value.pwrPatient) {
      emits("selectedPatient", selectedPatient.value.pwrPatient)
    } else {
      filteredPatients.value = [];
    }  
  }
)

watch(
  () => props.initialPatientSearch,
  () => { 
    setSearchText(props.initialPatientSearch);
  }
);

onMounted(async () => {
  focus()
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    ref_key: "searchInputRef",
    ref: searchInputRef,
    modelValue: selectedPatient.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPatient).value = $event)),
    options: filteredPatients.value,
    optionLabel: "label",
    size: "small",
    editable: "",
    onValueChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(debouncedSearchPatient)($event))),
    emptyMessage: _unref(t)('patient.search.noResult'),
    class: "w-full"
  }, null, 8, ["modelValue", "options", "emptyMessage"]))
}
}

})